import { Notification, NotificationStepStatus } from '@dynamik/common/clients/notification-clients';

export class NotificationStatusValueConverter {
  toView(n: Notification): { icon: string; class: string } {
    if (n?.steps.some(s => s.status === NotificationStepStatus.Error)) {
      return { icon: 'error', class: 'mdc-theme--error' };
    } else if (n?.steps.some(s => s.status === NotificationStepStatus.Warning)) {
      return { icon: 'warning', class: 'warning' };
    } else if (n?.steps.every(s => s.status === NotificationStepStatus.Success)) {
      return { icon: 'check', class: 'mdc-theme--primary' };
    } else {
      return { icon: 'schedule', class: '' };
    }
  }
}
